import { render, staticRenderFns } from "./BuildingGroupSelectModal.vue?vue&type=template&id=acce0536&"
import script from "./BuildingGroupSelectModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingGroupSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports